import { Box, Button, Stack, useTheme } from '@mui/material';
import {
  Description as ReportIcon,
  PlayArrow as RunIcon,
} from '@mui/icons-material';
import { alpha } from '@mui/material/styles';
import { getModernButton, layoutGap } from '../../../theme/theme';
import { BodyText, CompactPageTitle } from '../../../shared/ui/typography';
import ActionHelpTooltip from '../../../shared/ui/common/ActionHelpTooltip';
import { validationActionTooltips } from '../../../shared/config/actionHelpCatalog';
import { validationCopy } from '../copy/validationCopy';

type ValidationReadyEmptyStateProps = {
  readonly onRun?: () => void;
  readonly disableRun?: boolean;
};

export default function ValidationReadyEmptyState({
  onRun,
  disableRun,
}: ValidationReadyEmptyStateProps) {
  const theme = useTheme();
  const buttonStyles = getModernButton(theme);
  const copy = validationCopy.emptyState.ready;
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', py: 6, px: 3, textAlign: 'center', minHeight: '400px' }}>
      <Box sx={{ width: 96, height: 96, borderRadius: '50%', backgroundColor: alpha(theme.palette.primary.main, 0.08), display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2.5 }}>
        <ReportIcon sx={{ fontSize: 48, color: theme.palette.primary.main, opacity: 0.8 }} />
      </Box>
      <CompactPageTitle sx={{ color: theme.palette.text.primary, mb: 1 }}>{copy.title}</CompactPageTitle>
      <BodyText color="text.secondary" sx={{ mb: 3, maxWidth: 420 }}>{copy.description}</BodyText>
      <Stack direction="row" spacing={layoutGap.row} useFlexGap flexWrap="wrap" justifyContent="center">
        <ActionHelpTooltip help={validationActionTooltips.runValidation}>
          <Button variant="contained" size="large" startIcon={<RunIcon />} onClick={onRun} disabled={disableRun} sx={{ ...buttonStyles.contained, px: 4, py: 1 }}>
            {copy.run}
          </Button>
        </ActionHelpTooltip>
      </Stack>
    </Box>
  );
}
